var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconprofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.67253 25H24.4041C24.5824 25 24.7535 24.9291 24.8796 24.803C25.0057 24.6769 25.0766 24.5058 25.0766 24.3275C25.0766 24.1491 25.0057 23.978 24.8796 23.8519C24.7535 23.7258 24.5824 23.6549 24.4041 23.6549H1.67253C1.49416 23.6549 1.3231 23.7258 1.19698 23.8519C1.07086 23.978 1 24.1491 1 24.3275C1 24.5058 1.07086 24.6769 1.19698 24.803C1.3231 24.9291 1.49416 25 1.67253 25Z",
    fill: "#F3223C",
    stroke: "#F3223C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.96099 19.9453C10.5291 19.7863 11.0475 19.4854 11.4675 19.071L24.2994 6.23908C24.7388 5.79792 24.9855 5.20061 24.9855 4.57793C24.9855 3.95525 24.7388 3.35794 24.2994 2.91678L23.035 1.66587C22.5876 1.23849 21.9926 1 21.3738 1C20.7551 1 20.1601 1.23849 19.7127 1.66587L6.8808 14.4843C6.46564 14.9015 6.16858 15.4213 6.01996 15.9908L5.02462 19.7031C4.9774 19.8727 4.97618 20.0518 5.02109 20.222C5.06601 20.3922 5.15543 20.5474 5.28018 20.6716C5.47057 20.8588 5.7261 20.9648 5.99306 20.9675L9.96099 19.9453ZM10.5125 18.116C10.2645 18.3684 9.95325 18.5496 9.61128 18.6405L8.30657 18.9903L6.96151 17.6452L7.31122 16.3405C7.4053 15.9998 7.58603 15.6893 7.8358 15.4393L8.34692 14.9416L11.0236 17.6183L10.5125 18.116ZM11.9786 16.6633L9.30191 13.9866L18.3542 4.93437L21.0309 7.61105L11.9786 16.6633ZM23.3444 5.29754L21.9858 6.65605L19.3092 3.97938L20.6677 2.60742C20.7612 2.51355 20.8723 2.43907 20.9946 2.38825C21.1169 2.33743 21.2481 2.31127 21.3806 2.31127C21.513 2.31127 21.6442 2.33743 21.7665 2.38825C21.8889 2.43907 22 2.51355 22.0935 2.60742L23.3444 3.87177C23.532 4.06161 23.6372 4.31776 23.6372 4.58466C23.6372 4.85156 23.532 5.1077 23.3444 5.29754Z",
    fill: "#F3223C",
    stroke: "#F3223C",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconprofile);
export default __webpack_public_path__ + "static/media/editIconprofile.d2c184d71d990060bafc741882989cf0.svg";
export { ForwardRef as ReactComponent };